/* eslint-disable react/jsx-no-target-blank */
import { useIntl } from 'react-intl';
import { AsideMenuItemWithSub } from './AsideMenuItemWithSub';
import { AsideMenuItem } from './AsideMenuItem';
import {
  MustHavePermission,
  SWSection,
  SWResource,
  SWAction,
} from '../../../../app/core/shared/core/permissionUtils';
import { useAuth } from '../../../../app/modules/auth';

export function AsideMenuMain() {
  const intl = useIntl();
  const { currentUser } = useAuth();

  return (
    <>
      <AsideMenuItem
        to='/dashboard'
        icon='element-11'
        title={intl.formatMessage({ id: 'MENU.DASHBOARD' })}
      />

      <AsideMenuItemWithSub title='Reference Data' to='' icon='ki-duotone ki-basket'>
        <AsideMenuItem
          hasBullet={true}
          to='/rdm/unit/list'
          title='Locations'
          hasPermission={MustHavePermission(
            SWSection.Manufacturing,
            SWResource.Locations,
            SWAction.Search
          )}
        />
        <AsideMenuItem
          hasBullet={true}
          to='/rdm/process/list'
          title='Process'
          hasPermission={MustHavePermission(
            SWSection.Manufacturing,
            SWResource.Processes,
            SWAction.Search
          )}
        />
      </AsideMenuItemWithSub>

      <AsideMenuItemWithSub title='Catalog' to='' icon='ki-duotone ki-basket'>
        <AsideMenuItem
          to='/catalog/brands'
          title='Brands'
          hasBullet={true}
          hasPermission={MustHavePermission(
            SWSection.Manufacturing,
            SWResource.Brands,
            SWAction.Search
          )}
        />
        <AsideMenuItem
          to='/catalog/manufacturer'
          title='Manufacturer'
          hasBullet={true}
          hasPermission={MustHavePermission(
            SWSection.Manufacturing,
            SWResource.Manufacturers,
            SWAction.Search
          )}
        />
        <AsideMenuItem
          hasBullet={true}
          to='/catalog/raw-materials'
          title='Raw Materials'
          hasPermission={MustHavePermission(
            SWSection.Manufacturing,
            SWResource.RawMaterials,
            SWAction.Search
          )}
        />
        <AsideMenuItem
          hasBullet={true}
          to='/catalog/products/list'
          title='Products'
          hasPermission={MustHavePermission(
            SWSection.Manufacturing,
            SWResource.Products,
            SWAction.Search
          )}
        />
        <AsideMenuItem
          hasBullet={true}
          to='/catalog/categories/list'
          title='Categories'
          hasPermission={MustHavePermission(
            SWSection.Manufacturing,
            SWResource.Categories,
            SWAction.Search
          )}
        />
        <AsideMenuItem
          hasBullet={true}
          to='/catalog/design-number/list'
          title='Design Number'
          hasPermission={MustHavePermission(
            SWSection.Manufacturing,
            SWResource.DesignNumbers,
            SWAction.Search
          )}
        />
      </AsideMenuItemWithSub>

      <AsideMenuItemWithSub title='Sales' to='' icon='ki-duotone ki-basket'>
        <AsideMenuItem
          hasBullet={true}
          to='/sales/agent/list'
          title='Agent'
          hasPermission={MustHavePermission(
            SWSection.Manufacturing,
            SWResource.Agents,
            SWAction.Search
          )}
        />
        <AsideMenuItem
          hasBullet={true}
          to='/sales/customers/list'
          title='Customers'
          hasPermission={MustHavePermission(
            SWSection.Manufacturing,
            SWResource.Customers,
            SWAction.Search
          )}
        />
        {(currentUser?.staffDisplayModeId === 2 || currentUser?.staffDisplayModeId === 3) && (
          <AsideMenuItem
            to='/sales/sale-order-request/list'
            title='Sale Order Request'
            hasBullet={true}
            hasPermission={MustHavePermission(
              SWSection.Manufacturing,
              SWResource.SaleOrderRequests,
              SWAction.Search
            )}
          />
        )}
        {(currentUser?.staffDisplayModeId === 1 || currentUser?.staffDisplayModeId === 3) && (
          <AsideMenuItem
            to='/sales/sale-order-request/taxed-list'
            title={
              currentUser?.staffDisplayModeId === 1
                ? 'Sale Order Request'
                : 'Taxed Sale Order Request'
            }
            hasBullet={true}
            hasPermission={MustHavePermission(
              SWSection.Manufacturing,
              SWResource.TaxedSaleOrderRequests,
              SWAction.Search
            )}
          />
        )}
        {(currentUser?.staffDisplayModeId === 2 || currentUser?.staffDisplayModeId === 3) && (
          <AsideMenuItem
            to='/sales/sale-order-challan/list'
            title='Sale Order Challan'
            hasBullet={true}
            hasPermission={MustHavePermission(
              SWSection.Manufacturing,
              SWResource.SaleOrders,
              SWAction.Search
            )}
          />
        )}
        {(currentUser?.staffDisplayModeId === 1 || currentUser?.staffDisplayModeId === 3) && (
          <AsideMenuItem
            to='/sales/sale-order-challan/taxed-list'
            title={
              currentUser?.staffDisplayModeId === 1
                ? 'Sales Order Challan'
                : 'Taxed Sales Order Challan'
            }
            hasBullet={true}
            hasPermission={MustHavePermission(
              SWSection.Manufacturing,
              SWResource.TaxedSaleOrders,
              SWAction.Search
            )}
          />
        )}
        <AsideMenuItem
          hasBullet={true}
          to='/sales/track-order/order'
          title='Track Order'
          hasPermission={MustHavePermission(
            SWSection.Manufacturing,
            SWResource.SaleOrders,
            SWAction.Search
          )}
        />
        <AsideMenuItem
          hasBullet={true}
          to='/sales/track-order/taxed-order'
          title='Track Taxed Order'
          hasPermission={MustHavePermission(
            SWSection.Manufacturing,
            SWResource.TaxedSaleOrders,
            SWAction.Search
          )}
        />
        {(currentUser?.staffDisplayModeId === 2 || currentUser?.staffDisplayModeId === 3) && (
          <AsideMenuItem
            to='/sales/package/list'
            title='Package'
            hasBullet={true}
            hasPermission={MustHavePermission(
              SWSection.Manufacturing,
              SWResource.Packages,
              SWAction.Search
            )}
          />
        )}
        {(currentUser?.staffDisplayModeId === 1 || currentUser?.staffDisplayModeId === 3) && (
          <AsideMenuItem
            to='/sales/package/taxed-list'
            title={currentUser?.staffDisplayModeId === 1 ? 'Package' : 'Taxed Package'}
            hasBullet={true}
            hasPermission={MustHavePermission(
              SWSection.Manufacturing,
              SWResource.Packages,
              SWAction.Search
            )}
          />
        )}
        <AsideMenuItem
          to='/sales/invoice/list'
          title='Invoice'
          hasBullet={true}
          hasPermission={MustHavePermission(
            SWSection.Manufacturing,
            SWResource.Invoices,
            SWAction.Search
          )}
        />
        {(currentUser?.staffDisplayModeId === 2 || currentUser?.staffDisplayModeId === 3) && (
          <AsideMenuItem
            to='/sales/shipment/list'
            title='Shipment'
            hasBullet={true}
            hasPermission={MustHavePermission(
              SWSection.Manufacturing,
              SWResource.Shipments,
              SWAction.Search
            )}
          />
        )}
        {(currentUser?.staffDisplayModeId === 1 || currentUser?.staffDisplayModeId === 3) && (
          <AsideMenuItem
            to='/sales/shipment/taxed-list'
            title={currentUser?.staffDisplayModeId === 1 ? 'Shipment' : 'Taxed Shipment'}
            hasBullet={true}
            hasPermission={MustHavePermission(
              SWSection.Manufacturing,
              SWResource.Shipments,
              SWAction.Search
            )}
          />
        )}
      </AsideMenuItemWithSub>

      <AsideMenuItemWithSub title='WorkOrder' to='' icon='ki-duotone ki-basket'>
        <AsideMenuItem
          hasBullet={true}
          to='/workorder/casting-order/list'
          title='Casting Order'
          hasPermission={MustHavePermission(
            SWSection.Manufacturing,
            SWResource.CastingOrders,
            SWAction.Search
          )}
        />
        <AsideMenuItem
          hasBullet={true}
          to='/workorder/kadi-fitting/list'
          title='Kadi Fitting Order'
          hasPermission={MustHavePermission(
            SWSection.Manufacturing,
            SWResource.KadiFittingOrders,
            SWAction.Search
          )}
        />
        <AsideMenuItem
          hasBullet={true}
          to='/workorder/polishing-order/list'
          title='Polishing Order'
          hasPermission={MustHavePermission(
            SWSection.Manufacturing,
            SWResource.PolishingOrders,
            SWAction.Search
          )}
        />
        <AsideMenuItem
          hasBullet={true}
          to='/workorder/moti-piroing/list'
          title='Moti Piroing'
          hasPermission={MustHavePermission(
            SWSection.Manufacturing,
            SWResource.MotiPiroingOrders,
            SWAction.Search
          )}
        />
        <AsideMenuItem
          hasBullet={true}
          to='/workorder/moti-fitting/list'
          title='Moti Fitting'
          hasPermission={MustHavePermission(
            SWSection.Manufacturing,
            SWResource.MotiFittingOrders,
            SWAction.Search
          )}
        />
        <AsideMenuItem
          hasBullet={true}
          to='/workorder/pasting/list'
          title='Pasting'
          hasPermission={MustHavePermission(
            SWSection.Manufacturing,
            SWResource.PastingOrders,
            SWAction.Search
          )}
        />
        <AsideMenuItem
          hasBullet={true}
          to='/workorder/packing/list'
          title='Packing'
          hasPermission={MustHavePermission(
            SWSection.Manufacturing,
            SWResource.PackingOrders,
            SWAction.Search
          )}
        />
        <AsideMenuItem
          hasBullet={true}
          to='/workorder/process-stock/list'
          title='Process Stock'
          hasPermission={MustHavePermission(
            SWSection.Manufacturing,
            SWResource.ProcessOrderStocks,
            SWAction.Search
          )}
        />
      </AsideMenuItemWithSub>

      <AsideMenuItemWithSub title='Purchase' to='' icon='ki-duotone ki-basket'>
        {(currentUser?.staffDisplayModeId === 2 || currentUser?.staffDisplayModeId === 3) && (
          <AsideMenuItem
            to='/purchase/bills/list'
            title='Bills'
            hasBullet={true}
            hasPermission={MustHavePermission(
              SWSection.Manufacturing,
              SWResource.Bills,
              SWAction.Search
            )}
          />
        )}
        {(currentUser?.staffDisplayModeId === 1 || currentUser?.staffDisplayModeId === 3) && (
          <AsideMenuItem
            to='/purchase/bills/taxed-list'
            title={currentUser?.staffDisplayModeId === 1 ? 'Bills' : 'Taxed Bills'}
            hasBullet={true}
            hasPermission={MustHavePermission(
              SWSection.Manufacturing,
              SWResource.Bills,
              SWAction.Search
            )}
          />
        )}
        <AsideMenuItem
          hasBullet={true}
          to='/purchase/vendor/list'
          title='Vendor'
          hasPermission={MustHavePermission(
            SWSection.Manufacturing,
            SWResource.Vendors,
            SWAction.Search
          )}
        />
        <AsideMenuItem
          hasBullet={true}
          to='/purchase/purchase-order/list'
          title='Purchase Order'
          hasPermission={MustHavePermission(
            SWSection.Manufacturing,
            SWResource.PurchaseOrders,
            SWAction.Search
          )}
        />
        <AsideMenuItem
          hasBullet={true}
          to='/purchase/purchase-receive/list'
          title='Purchase Receive'
          hasPermission={MustHavePermission(
            SWSection.Manufacturing,
            SWResource.PurchaseReceives,
            SWAction.Search
          )}
        />
        {/* <AsideMenuItem hasBullet={true} to='/purchase/payment/list' title='Payment' hasPermission={MustHavePermission(SWSection.Manufacturing, SWResource.PurchaseOrders, SWAction.Create)}/> */}
      </AsideMenuItemWithSub>

      <AsideMenuItemWithSub title='Accounting' to='' icon='ki-duotone ki-gear'>
        <AsideMenuItem
          to='/purchase/expensecategory/list'
          title='Expense Category'
          hasBullet={true}
          hasPermission={MustHavePermission(
            SWSection.Manufacturing,
            SWResource.ExpenseCategories,
            SWAction.Search
          )}
        />
        <AsideMenuItem
          to='/purchase/expense/list'
          title='Expense'
          hasBullet={true}
          hasPermission={MustHavePermission(
            SWSection.Manufacturing,
            SWResource.Expenses,
            SWAction.Search
          )}
        />
        {(currentUser?.staffDisplayModeId === 2 || currentUser?.staffDisplayModeId === 3) && (
          <AsideMenuItem
            hasBullet={true}
            to='/sales/payment/list'
            title='Payment Received'
            hasPermission={MustHavePermission(
              SWSection.Manufacturing,
              SWResource.SaleOrders,
              SWAction.Create
            )}
          />
        )}

        {(currentUser?.staffDisplayModeId === 1 || currentUser?.staffDisplayModeId === 3) && (
          <AsideMenuItem
            hasBullet={true}
            to='/sales/payment/taxed-list'
            title={
              currentUser?.staffDisplayModeId === 1 ? 'Payment Received' : 'Taxed Payment Received'
            }
            hasPermission={MustHavePermission(
              SWSection.Manufacturing,
              SWResource.PaymentReceived,
              SWAction.Search
            )}
          />
        )}

        {(currentUser?.staffDisplayModeId === 2 || currentUser?.staffDisplayModeId === 3) && (
          <AsideMenuItem
            to='/purchase/payment-made/list'
            title='Payment Made'
            hasBullet={true}
            hasPermission={MustHavePermission(
              SWSection.Manufacturing,
              SWResource.PaymentMades,
              SWAction.Search
            )}
          />
        )}

        {(currentUser?.staffDisplayModeId === 1 || currentUser?.staffDisplayModeId === 3) && (
          <AsideMenuItem
            to='/purchase/payment-made/taxed-list'
            title={currentUser?.staffDisplayModeId === 1 ? 'Payment Made' : ' Taxed Payment Made'}
            hasBullet={true}
            hasPermission={MustHavePermission(
              SWSection.Manufacturing,
              SWResource.PaymentMades,
              SWAction.Search
            )}
          />
        )}

        {(currentUser?.staffDisplayModeId === 2 || currentUser?.staffDisplayModeId === 3) && (
          <AsideMenuItem
            to='/accounting/credit-note/list'
            title='Credit Note'
            hasBullet={true}
            hasPermission={MustHavePermission(
              SWSection.Manufacturing,
              SWResource.CreditNotes,
              SWAction.Search
            )}
          />
        )}

        {(currentUser?.staffDisplayModeId === 1 || currentUser?.staffDisplayModeId === 3) && (
          <AsideMenuItem
            to='/accounting/credit-note/taxed-list'
            title={currentUser?.staffDisplayModeId === 1 ? 'Credit Note' : 'Taxed Credit Note'}
            hasBullet={true}
            hasPermission={MustHavePermission(
              SWSection.Manufacturing,
              SWResource.CreditNotes,
              SWAction.Search
            )}
          />
        )}

        {(currentUser?.staffDisplayModeId === 2 || currentUser?.staffDisplayModeId === 3) && (
          <AsideMenuItem
            to='/accounting/debit-note/list'
            title='Debit Note'
            hasBullet={true}
            hasPermission={MustHavePermission(
              SWSection.Manufacturing,
              SWResource.DebitNotes,
              SWAction.Search
            )}
          />
        )}

        {(currentUser?.staffDisplayModeId === 1 || currentUser?.staffDisplayModeId === 3) && (
          <AsideMenuItem
            to='/accounting/debit-note/taxed-list'
            title={currentUser?.staffDisplayModeId === 1 ? 'Debit Note' : 'Taxed Debit Note'}
            hasBullet={true}
            hasPermission={MustHavePermission(
              SWSection.Manufacturing,
              SWResource.DebitNotes,
              SWAction.Search
            )}
          />
        )}
      </AsideMenuItemWithSub>

      <AsideMenuItem to='/reports/list' title='Reports' icon='ki-duotone ki-basket' />

      {/* <AsideMenuItemWithSub title='Reports' to='' icon='ki-duotone ki-basket'>
        <AsideMenuItem
          hasBullet={true}
          to='/reports/stocks/rawmaterial/list'
          title='Raw Material'
        />
        <AsideMenuItem hasBullet={true} to='/reports/stocks/productstock/list' title='Products' />
        <AsideMenuItem hasBullet={true} to='/reports/stocks/sales-customer/list' title='Sales By Customer' />
          <AsideMenuItem hasBullet={true} to='/reports/stocks/sales-agent/list' title='Sales By Agent' />
          <AsideMenuItem hasBullet={true} to='/reports/stocks/sales-product/list' title='Sales By Product' />
          <AsideMenuItem hasBullet={true} to='/reports/stocks/sales-design-number/list' title='Sales By Design Number' />
          <AsideMenuItem hasBullet={true} to='/reports/stocks/purchase-vendor/list' title='Purchase By Vendor' />
          <AsideMenuItem hasBullet={true} to='/reports/stocks/purchase-product/list' title='Purchase By RawMaterial' />

          <AsideMenuItem hasBullet={true} to='/reports/stocks/expense/list' title='Expense' />
          <AsideMenuItem hasBullet={true} to='/reports/stocks/expense-category/list' title='Expense Category' />
      </AsideMenuItemWithSub> */}

      {/* <AsideMenuItemWithSub title='Low Stock Report' to='' icon='ki-duotone ki-basket'>
        <AsideMenuItem
          hasBullet={true}
          to='/reports/lowstock/rawmaterial'
          title='Raw Material'
        />
        <AsideMenuItem
          hasBullet={true}
          to='/reports/lowstock/product/list'
          title='Products'
        />
      </AsideMenuItemWithSub> */}

      <AsideMenuItemWithSub title='Settings' to='' icon='ki-duotone ki-gear'>
        <AsideMenuItem
          to='/settings/general'
          title='General'
          hasBullet={true}
          hasPermission={MustHavePermission(
            SWSection.Manufacturing,
            SWResource.OrganizationProfiles,
            SWAction.View
          )}
        />
        <AsideMenuItem
          to='/settings/salesetting'
          title='Sales'
          hasBullet={true}
          hasPermission={MustHavePermission(
            SWSection.Manufacturing,
            SWResource.SalesOrderSettings,
            SWAction.View
          )}
        />
        <AsideMenuItem
          hasBullet={true}
          to='/settings/role/list'
          title='Role'
          hasPermission={MustHavePermission(
            SWSection.Manufacturing,
            SWResource.Roles,
            SWAction.View
          )}
        />
        <AsideMenuItem
          hasBullet={true}
          to='/settings/staff/list'
          title='Staff'
          hasPermission={MustHavePermission(
            SWSection.Manufacturing,
            SWResource.Staffs,
            SWAction.View
          )}
        />
        <AsideMenuItem
          hasBullet={true}
          to='/settings/paymentmode/list'
          title='Payment Mode'
          hasPermission={MustHavePermission(
            SWSection.Manufacturing,
            SWResource.PaymentModes,
            SWAction.View
          )}
        />

        <AsideMenuItem
          to='/settings/customervendor'
          title='Customer Vendor'
          hasBullet={true}
          hasPermission={MustHavePermission(
            SWSection.Manufacturing,
            SWResource.CustomerVendorSettings,
            SWAction.View
          )}
        />
        {/* <AsideMenuItem to='/settings/emailsetting' title='Email Setting' hasBullet={true} /> */}
        <AsideMenuItem
          to='/settings/purchasesetting'
          title='Purchase Order'
          hasBullet={true}
          hasPermission={MustHavePermission(
            SWSection.Manufacturing,
            SWResource.PurchaseOrderSettings,
            SWAction.View
          )}
        />
        {/* <AsideMenuItem to='/settings/emailtemplate/list' title='Email Template' hasBullet={true} /> */}
        <AsideMenuItem
          to='/settings/autonumbergeneration-setting'
          title='Series Setting'
          hasBullet={true}
          hasPermission={MustHavePermission(
            SWSection.Manufacturing,
            SWResource.AutoNumberGenerationGroups,
            SWAction.View
          )}
        />

        <AsideMenuItem
          to='/settings/bank-account/list'
          title='Bank Account'
          hasBullet={true}
          hasPermission={MustHavePermission(
            SWSection.Manufacturing,
            SWResource.Banks,
            SWAction.View
          )}
        />
      </AsideMenuItemWithSub>
    </>
  );
}
